module.exports = __webpack_public_path__ + "static/media/64.f6260545.jpg";